import {
  PARTNER_MODULE_ALLOCATION_SUCCESS,
  PARTNER_MODULE_ALLOCATION_FAILED,
  RESET_PARTNER_MODULE_ALLOCATION,
  LOADING_PARTNER_MODULE_ALLOCATION,
  NETWORK_ERROR_PARTNER_MODULE_ALLOCATION,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetPartnerGetModuleAllocation = () => {
  return { type: RESET_PARTNER_MODULE_ALLOCATION };
};

const PartnerGetModuleAllocation =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_PARTNER_MODULE_ALLOCATION });
    await partnerServices
      .post("getModuleAllocationList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(PartnerGetModuleAllocationsuccess(res.data));
            break;
          case "Failed":
            dispatch(PartnerGetModuleAllocationsuccess(res.data));
            break;

          default:
            dispatch(PartnerGetModuleAllocationFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_PARTNER_MODULE_ALLOCATION,
          payload: err,
        });
      });
  };
function PartnerGetModuleAllocationsuccess(data) {
  return {
    type: PARTNER_MODULE_ALLOCATION_SUCCESS,
    payload: data,
  };
}
function PartnerGetModuleAllocationFailed(data) {
  return {
    type: PARTNER_MODULE_ALLOCATION_FAILED,
    payload: data,
  };
}

export { resetPartnerGetModuleAllocation, PartnerGetModuleAllocation };
